import React, { ReactNode } from "react"
import { Tooltip } from "react-tooltip"
import { ButtonStyle } from "../models/ButtonStyle"
import { FeatureService } from "../services/FeatureService"

export interface DropdownButtonProps {
    label: string
    id?: string
    style?: ButtonStyle
    menuItems: string[]
    position?: DropdownMenuPosition
    onItemSelected(item: string): void
    disabled?: boolean
    tooltip?: ReactNode
    tooltipAtDisabled?: boolean
}

interface DropdownButtonState {
    menuShown: boolean
}

export enum DropdownMenuPosition {
    LEFT = "left",
    RIGHT = "right",
}

export class DropdownButton extends React.Component<DropdownButtonProps, DropdownButtonState> {
    constructor(props: DropdownButtonProps) {
        super(props)

        this.state = {
            menuShown: false,
        }
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState({ menuShown: false })
    }

    toggleMenuShown = () => {
        this.setState({ menuShown: !this.state.menuShown })
    }

    onItemClicked = (item: string) => {
        this.setState({ menuShown: false })
        this.props.onItemSelected(item)
    }

    render() {
        const style = this.props.style || ButtonStyle.SECONDARY
        const show = this.state.menuShown
        const disabled = this.props.disabled
        let tooltip = undefined
        if (this.props.tooltip) {
            if (this.props.tooltipAtDisabled) {
                tooltip = { "data-tooltip-content": "custom", "data-tooltip-id": `${this.props.id}-tooltip` }
            } else {
                tooltip = { "data-tooltip-content": "", "data-tooltip-id": `${this.props.id}` }
            }
        }
        return (
            <div className={`dropdown ${show ? "show" : ""}`}>
                <button
                    id={this.props.id}
                    className={`btn btn-${style} dropdown-toggle ${this.props.tooltipAtDisabled ? "tooltip-button" : ""}`}
                    type="button"
                    onClick={this.toggleMenuShown}
                    aria-haspopup="true"
                    aria-expanded={show}
                    disabled={disabled}
                >
                    {this.props.tooltipAtDisabled && <span className="tooltip-button-overlay" {...tooltip}></span>}
                    {this.props.label}
                </button>
                {FeatureService.isFeatureActive("DEMO") && (
                    <Tooltip id={`${this.props.id}-tooltip`} place="top" variant="dark" float={true}>
                        {this.props.tooltip}
                    </Tooltip>
                )}
                <div className={`dropdown-menu ${show ? "show" : ""}`} aria-labelledby={this.props.id}>
                    {this.props.menuItems.map((item, index) => (
                        <button key={index} className="dropdown-item" onClick={this.onItemClicked.bind(null, item)}>
                            {item}
                        </button>
                    ))}
                </div>
            </div>
        )
    }
}
